import React from 'react'
import { Navigate } from 'react-router-dom'
import { useAuth } from 'contexts/AuthContext'

/** Full-screen Assistant mode. The side drawer does not use this path. */
export const ASSISTANT_WORKSPACE_PATH = '/admin/assistant'

/** Registered under the portal layout so the assistant shell stays mounted. */
export const AssistantWorkspaceRoute: React.FC = () => {
  const { userInfo } = useAuth()
  if (userInfo && userInfo.role !== 'admin') {
    return <Navigate to='/admin' replace />
  }
  return null
}
